import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { MDBModalRef } from '../../app/shared/services/mdb-modal-stub.service';
import { Constants } from '../shared/models/constants';
import { Enums } from '../shared/models/enums';
import { CellRendererElementTypes } from '../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../shared/widgets/data-grid/enums/cell-renderer.enum';
import { EditableTypes } from '../shared/widgets/data-grid/enums/editable-types.enum';
import { FilterTypes } from '../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../shared/widgets/data-grid/interfaces/table-column.interface';
@Injectable({
    providedIn: 'root'
})
export class DatabaseAdminGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    dropDowns = {
        countries: [],
        city: [],
        buildingType: [],
        buildingActivity: [],
        buildingCategory: [],
    };
    effectiveDate: Date;
    constructor(
       ) { }

    dateCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], Constants.DATETIME_FORMAT, 'en-US');            
           
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    dataCellRenderer(rowData: any) {
        return rowData.countryName;
    }

    editedCellRenderer(rowData: any, field: any) {
        let isUpdated = false;
        let originalData = '';
        const displayValue = rowData[field];
        if (rowData[field] !== undefined && rowData[field] !== null) {
            switch (field) {
                case 'countryName':
                    isUpdated = rowData.isCountryNameUpdated;
                    originalData = rowData.countryName;
                    break;    
                case 'countryISO':
                    isUpdated = rowData.isCountryISOUpdated;
                    originalData = rowData.countryISO;
                    break; 
                case 'effectiveDate':
                    isUpdated = rowData.isEffectiveDateUpdated;
                    originalData = rowData.effectiveDate;
                    break; 
                default:
                    isUpdated = false;
                    break;
            }

            if (isUpdated) {
                if (originalData == null) {
                    originalData = `'No Value'`;
                }
                return `<span class="text-edgeblue" title="Original Value : ${originalData}">${displayValue}</span>`;
            } else {
                return `<span title=${displayValue}>${displayValue}<span>`;
            }
        } else {
            return '';
        }
    }

    approveRejectRenderer(rowData: any, field: any) {

        if (rowData.isSave || rowData.isApprove || rowData.isReject) {
            if (rowData.isSave) {
                return `<span title="Save">Save</span> <span title="Discard">Discard</span>`;
            }
            if (rowData.isApprove) {
                return `<span title="Approve">Approve</span> <span title="Return">Return</span>`;
            }           
        } else { return ''; } 
    }

    cols: Array<TableColumn> = [   
        {
            field: 'country',
            header: 'Country Name',
            pinned: true,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'country',
            filter: { type: FilterTypes.text },
            //editable: {
            //    type: EditableTypes.text,
            //    maxlength: 100
            //}
        },
        {
            field: 'countryName',
            header: 'Country Name',
            pinned: true,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'countryName',
            filter: { type: FilterTypes.text }         

        },       
        {
            field: 'countryISO',
            header: 'Country ISO',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'countryISO',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 100
            },
        },
        {
            field: 'city',
            header: 'City Name',
            pinned: true,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'city',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 200
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.editedCellRenderer

            }
        },
        {
            field: 'cityName',
            header: 'City Name',
            pinned: true,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'cityName',
            filter: { type: FilterTypes.text }            
        },
        {
            field: 'cityCode',
            header: 'City Code',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'cityCode',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 100
            },
        },
        {
            field: 'currencySymbol',
            header: 'Currency Symbol',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'currencySymbol',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 16
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.editedCellRenderer

            }
        },
        {
            field: 'currency',
            header: 'Currency',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'currency',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'currencyRepresentation',
            header: 'Currency Representation',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'currencyRepresentation',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'cO2PerkWh_ElectricityGeneration_gCO2PerkWh',
            header:'CO2/kWh ElectricityGeneration gCO2/kWh',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'cO2PerkWh_ElectricityGeneration_gCO2PerkWh',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'electricityCostperkWh',
            header: 'Electricity Cost/kWh',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'electricityCostperkWh',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'dieselFuel',
            header: 'Diesel Fuel',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'dieselFuel',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'cO2PerkWhfromHeatGeneration2005gCO2PerkWh',
            header: 'CO2/kWh from HeatGeneration 2005gCO2/kWh',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'cO2PerkWhfromHeatGeneration2005gCO2PerkWh',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'costofDieselfuelPerLitre',
            header: 'Cost of Diesel fuel/Litre',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'costofDieselfuelPerLitre',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'naturalGas',
            header: 'Natural Gas',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'naturalGas',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'cO2PerkWhfromHeatGeneration2005gCO2PerkWh1',
            header: 'CO2/kWh from HeatGeneration 2005gCO2/kWh1',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'cO2PerkWhfromHeatGeneration2005gCO2PerkWh1',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'costofGasperLitre',
            header: 'Cost of Gas/Litre',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'costofGasperLitre',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'costofLPGPerLitre',
            header: 'Cost of LPG/Litre',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'costofLPGPerLitre',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'water',
            header: 'Water',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'water',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'costofWaterPerm3',
            header: 'Cost of Water/m�',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'costofWaterPerm3',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 16
            },
        },
        {
            field: 'secondaryBuildingType',
            header: 'Secondary Building Type',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'secondaryBuildingType',
            filter: { type: FilterTypes.text }           
        },
        {
            field: 'activityType',
            header: 'Activity Type',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'activityType',
            filter: { type: FilterTypes.text }           
        },
        {
            field: 'value',
            header: 'Value',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'value',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },
        {
            field: 'buildingCategory',
            header: 'Building Category',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'buildingCategory',
            filter: { type: FilterTypes.text }
            
        },
        {
            field: 'shortcodeBSM',
            header: 'Shortcode BSM',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'shortcodeBSM',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 100
            },
        },
        {
            field: 'baseCaseMaterials',
            header: 'BaseCase Materials',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseMaterials',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 600
            },
        },
        {
            field: 'shortcodeBCMThickness',
            header: 'Shortcode BCM Thickness ',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'ShortcodeBCMThickness',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.text,
                maxlength: 100
            },
        },
        {
            field: 'baseCaseMaterialsThickness',
            header: 'BaseCase Materials Thickness',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseMaterialsThickness',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },
        {
            field: 'waterFixtureBaseCaseFlow',
            header: 'Water Fixture BaseCase Flow',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'waterFixtureBaseCaseFlow',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },  
        {
            field: 'direction',
            header: 'Direction',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'direction',
            filter: { type: FilterTypes.text }            
        },
        {
            field: 'baseCaseWallUValue',
            header: 'Base Case Wall UValue',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseWallUValue',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        }, 
        {
            field: 'baseCaseRoofUValue',
            header: 'Base Case Roof UValue',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseRoofUValue',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },
        {
            field: 'baseCaseGlassUValue',
            header: 'Base Case Glass UValue',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseGlassUValue',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },
        {
            field: 'baseCaseSHGCValue',
            header: 'Base Case SHGC Value',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'baseCaseSHGCValue',
            filter: { type: FilterTypes.text },
            editable: {
                type: EditableTypes.decimal,
                maxlength: 8
            },
        },
        {
            field: 'effectiveDate',
            header: 'Effective Date',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'effectiveDate',            
            editable: {
                type: EditableTypes.calender                
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastModified',
            header: 'Last Modified Date',
            pinned: false,
            sort: true,
            hideEditIcon: true,
            editDatabaseRecord: false,
            sortName: 'lastModified',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
            
        },

        {
            field: 'approvereject',
            header: 'Action',
            pinned: false,  
            editDatabaseRecord: true,
            cellRenderer: {
                type: CellRendererTypes.eventHtml,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onEventClick',
                renderHtml: this.approveRejectRenderer
            }
        }        
    ];

    getDefaultColumns(columns: any[] = [], role = '') {
        let col = [];
        if (!columns) {
            return this.cols;
        }
        const newColumns = _.cloneDeep(this.cols);
        col = _.filter(newColumns, (v) => _.includes(columns, v.field));
        if (columns.includes('')) {
            col[1].pinned = true;
        } else {
            col[1].pinned = false;
        }
       
        return col;
    }
}

